import { env } from "configs/EnvironmentConfig";
import fetch from "../auth/FetchInterceptor";

const timeSlotService = {};

timeSlotService.getTimeSlots = ({ params }) => {
  return fetch({
    url: `${env.API_MSP}/time-slots`,
    method: "get",
    params: {
      ...params,
      sort: params.sort || "from_time",
      "filter[record_status]": "O",
    },
  });
};

timeSlotService.getTimeSlotsV2 = ({ params }) => {
  const { columnFilter, columnFilterKeep, sort, ...otherParams } = params;

  return fetch({
    url: `${env.API_MSP}/time-slots`,
    method: "get",
    params: {
      record_status: "O",
      sort: sort || "from_time",
      ...otherParams,
      ...columnFilter,
      ...columnFilterKeep,
    },
  });
};

// Create Timeslot
timeSlotService.createTimeSlot = data => {
  return fetch({
    url: `${env.API_MSP}/time-slots`,
    method: "post",
    data: {
      ...data,
    },
  });
};

// Update Timeslot
timeSlotService.updateTimeSlot = ({ id, data }) => {
  return fetch({
    url: `${env.API_MSP}/time-slots/${id}`,
    method: "put",
    data: {
      ...data,
    },
  });
};

// Delete Timeslot
timeSlotService.deleteTimeSlot = id => {
  return fetch({
    url: `${env.API_MSP}/time-slots/${id}`,
    method: "delete",
  });
};
// Active Timeslot
timeSlotService.activeTimeSlot = id => {
  return fetch({
    url: `${env.API_MSP}/time-slots/${id}`,
    method: "put",
    data: {
      record_status: "O",
    },
  });
};

timeSlotService.getTimeSlotsSchedule = ({ params }) => {
  return fetch({
    url: `${env.API_MSP}/runner-schedule-changes/get-time-slot`,
    method: "get",
    params: {
      date: params.date || undefined,
      hub_id: params.hub_id || undefined,
    },
  });
};

timeSlotService.listType = () => {
  return fetch({
    url: `${env.API_MSP}/time-slots/list-type`,
    method: "get",
  });
};

export default timeSlotService;
